import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ContentPagesIcon = createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M13.73,4H10A2,2,0,0,0,8,6V18H5a2,2,0,0,1-2-2V5A2,2,0,0,1,5,3h7A2,2,0,0,1,13.73,4Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M19,6H12a2,2,0,0,0-2,2V19a2,2,0,0,0,2,2h7a2,2,0,0,0,2-2V8A2,2,0,0,0,19,6Zm-.52,13h-6a.51.51,0,0,1-.37-.87l1.35-1.34a.53.53,0,0,1,.74,0l.61.6,1.25-1.24a.53.53,0,0,1,.74,0l2,2A.51.51,0,0,1,18.48,19ZM12,15a1,1,0,1,1,1,1A1,1,0,0,1,12,15Zm6.5-3h-6a.5.5,0,0,1,0-1h6a.5.5,0,0,1,0,1Zm0-3h-6a.5.5,0,0,1,0-1h6a.5.5,0,0,1,0,1Z"
  })]
}), 'ContentPagesIcon');